/**
 * Uçuş süresi gösterimi (dakika → okunabilir Türkçe).
 */
export function formatFlightDuration(minutes) {
  const total = Math.max(0, Math.round(Number(minutes) || 0));
  if (total <= 0) return '';

  const days = Math.floor(total / 1440);
  const hours = Math.floor((total % 1440) / 60);
  const mins = total % 60;
  const parts = [];

  if (days > 0) parts.push(`${days} gün`);
  if (hours > 0) parts.push(`${hours} sa`);
  if (mins > 0 || parts.length === 0) parts.push(`${mins} dk`);

  return parts.join(' ');
}

export function arrivalDayOffset(departureTime, arrivalTime) {
  if (!departureTime || !arrivalTime) return 0;
  const dep = new Date(departureTime);
  const arr = new Date(arrivalTime);
  if (Number.isNaN(dep.getTime()) || Number.isNaN(arr.getTime())) return 0;
  dep.setHours(0, 0, 0, 0);
  arr.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((arr - dep) / 86400000));
}
